module.exports = __webpack_public_path__ + "static/img/left-bottom-row-7.d4a68424.png";